import { Button, Col, Row } from 'UI'
import CardRenderer from '../CardRenderer'
import { CourseNeutralPath } from 'navigation/Routes'
import { createUseStyles } from 'react-jss'
import style from './style'
import { useState } from 'react'
import Text from './text.json'

const useStyle = createUseStyles(style)

export default ({
  loading,
  loadingCount = 4,
  courses = [],
  columnGap = 44,
  columnDesktopGap = 44,
  tabletColumnGap = 24,
  mobileColumnGap = 0,
  rowGap = 24,
  rowDesktopGap = 24,
  tabletRowGap = 24,
  mobileRowGap = 24,
  columnCount = 4,
  columnDesktopCount = 4,
  tabletColumnCount = 2,
  mobileColumnCount = 1,
  handleCardClick,
  containerMarginBottom = 64,
  containerMarginBottomTablet = 32,
  containerMarginBottomMobile = 32,
  activateLocalPagination,
  paginationCount = 12,
  showMoreProps,
  showLoadingMore = false
}) => {
  const [displayedCourses, setDisplayedCourses] = useState(paginationCount)
  const courseSlice = courses.slice(0, displayedCourses)
  const width = `calc((100% / ${columnCount}) - ((${columnGap}px * ${columnCount - 1}) / ${columnCount}))`
  const desktopWidth = `calc((100% / ${columnDesktopCount}) - ((${columnDesktopGap}px * ${columnDesktopCount - 1}) / ${columnDesktopCount}))`
  const tabletWidth = `calc((100% / ${tabletColumnCount}) - ((${tabletColumnGap}px * ${tabletColumnCount - 1}) / ${tabletColumnCount}))`
  const mobileWidth = `calc((100% / ${mobileColumnCount}) - ((${mobileColumnGap}px * ${mobileColumnCount - 1}) / ${mobileColumnCount}))`
  const loadingCourses = [...Array(loadingCount)].map(_ => ({ loading: true }))
  const { container } = useStyle({
    containerMarginBottom,
    containerMarginBottomTablet,
    containerMarginBottomMobile,
    rowGap,
    rowDesktopGap,
    tabletRowGap,
    mobileRowGap,
    columnGap,
    columnDesktopGap,
    tabletColumnGap,
    mobileColumnGap
  })
  const showMoreCourses = () => {
    if (displayedCourses >= courses.length) {
      setDisplayedCourses(paginationCount)
    } else {
      setDisplayedCourses((prevCount) => prevCount + (columnCount * 2))
    }
  }
  const coursersToShow = activateLocalPagination ? courseSlice : courses
  return (
    <>
      <div className={container}>
        {(!showLoadingMore && loading ? loadingCourses : coursersToShow).map((course, index) => (
          <CardRenderer
            key={loading ? `loading-${index}` : course.Id}
            height={245}
            loading={!showLoadingMore && loading}
            course={course}
            handleCardClick={(course) => handleCardClick(course)}
            path={`${CourseNeutralPath}/${course.Slug}`}
            width={width}
            desktopWidth={desktopWidth}
            tabletWidth={tabletWidth}
            mobileWidth={mobileWidth}
          />
        ))}
        {
          showLoadingMore && loading && (
            loadingCourses.map((course, index) => (
              <CardRenderer
                key={`loading-${index}`}
                height={245}
                loading={loading}
                width={width}
                desktopWidth={desktopWidth}
                tabletWidth={tabletWidth}
                mobileWidth={mobileWidth}
              />
            ))
          )
        }
      </div>
      {activateLocalPagination && !loading && displayedCourses < courses.length && (
        <Row justify='center'>
          <Col grid={12}>
            <Button
              variation='text'
              onHandleClick={showMoreCourses}
              align='center'
              label={Text.showMore}
              {...showMoreProps}
            />
          </Col>
        </Row>
      )}
    </>
  )
}
